/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define(
  'screens/scenario-mapper/scenario',[
    'require',
    'plugins/chatmapper-debug/chatmapper-debug',
    'screens/scenario-mapper/scenario-actor',
    'screens/scenario-mapper/scenario-dialog',
    'screens/scenario-mapper/scenario-item',
    'screens/scenario-mapper/scenario-conversation',
    'screens/scenario-mapper/scenario-variable',
    'screens/scenario-mapper/scenario-link',
    'screens/scenario-mapper/scenario-location'
  ],
  function(require, ChatmapperDebug, ScenarioActor, ScenarioDialog, ScenarioItem, ScenarioConversation, ScenarioVariable, ScenarioLink, ScenarioLocation) {
    'use strict';

    /////////////
    // IMPORTS /{
    /////////////

    var $ = require('jquery');
    var _ = require('underscore');
    //var templates = require('core/templates');
    var Engine = require('core/engine');
    var Marionette = require('marionette');
    //var ChatmapperDebug = require('plugins/chatmapper-debug/chatmapper-debug');//], function(a) {
      //ChatmapperDebug = a;
    //});

    /*****************************************************************************************************************///}

    var Scenario = Marionette.Object.extend({

    /////////////////
    // PROPERTIES //{
    /////////////////

      // events: {
      //   'click .btn': 'btnPressed'
      // },
      actors: { },
      conversations: { },
      items: { },
      locations: { },
      vars: { },

      firstConversation: null,
      activeConversation: null,
      lastConversation: null,

      activeDialog: null,

      conversationWaitCount: 0,

      ended: false,
      failed: false,
      assetsMapped: false,

    /*****************************************************************************************************************///}

    //////////////
    // METHODS //{
    //////////////

      initialize: function(data)
      {
        //console.log('Scenario::initialize');
        Scenario.singleton = this;

        this.parseScenarioData(data);
        this.registerDialogNodes();
        ////console.log(this);
      },

      begin: function()
      {
        //console.log('scenario Begin');
        this.ended = false;
        this.failed = false;
        this.firstConversation.begin();
        Scenario.buildDebug();
      },

      getConversationByID: function($id)
      {
        return this.conversations[$id];
      },

      callMethod: function($methodName, $value)
      {
        $value = ($value === undefined) ? null : $value;

        var $leftLimit = 100;//(this.activeConversation.bg.background_mc.leftLimit_mc) ? -(this.activeConversation.bg.background_mc.leftLimit_mc.x) : 200;
        var $rightLimit = -100;//(this.activeConversation.bg.background_mc.leftLimit_mc) ? (1013 - this.activeConversation.bg.background_mc.rightLimit_mc.x) : -200;
        switch ($methodName)
        {
          case 'lookRight':
            //Tweener.addTween(this.activeConversation.bg.background_mc, { x: $rightLimit, time:1 } );
            this.activeConversation.bgContainerMC.animate({left: $rightLimit}, 500);
            //this.dispatchEvent(new Event(Scenario.SHOW_BLOCKER));
            break;
          case 'lookLeft':
            //Tweener.addTween(this.activeConversation.bg.background_mc, { x: $leftLimit, time:1 } );
            this.activeConversation.bgContainerMC.animate({left: $leftLimit}, 500);
            //this.dispatchEvent(new Event(Scenario.SHOW_BLOCKER));
            break;
          case 'lookMain':
            //Tweener.addTween(this.activeConversation.bg.background_mc, { x: 0, time:1 } );
            this.activeConversation.bgContainerMC.animate({left: 0}, 500);
            //this.dispatchEvent(new Event(Scenario.HIDE_BLOCKER));
            break;
          case 'finish':
            Scenario.finishScenario();
            break;
          case 'updateFrames':
            Scenario.updateItemFrames();
            break;
          case 'setAchievement':
            //Achievement.setAchievementCompleteByCode($value);
            break;
          default:
            console.warn('Unknown Chatmapper Method: ' + $methodName);
            break;
        }
      },

      onBeforeDestroy: function()
      {
        //var $dialog;
        _.each(ScenarioDialog.instancesArr, function($dialog) {
          $dialog.off('FOLLOW_DIALOG_LINK', this.onFollowDialogLink);
          $dialog.off('DIALOG_COMPLETE', this.onDialogCompleteHandler);
          $dialog.off(Scenario.UPDATE_FEEDBACK_PROGRESS, this.onFeedbackProgressHandler);
        }, this);

        Scenario.clearDebug(true);
        ScenarioActor.destroy();
        ScenarioLocation.destroy();
        ScenarioDialog.destroy();
        ScenarioItem.destroy();
        ScenarioConversation.destroy();
        ScenarioVariable.destroy();
        ScenarioLink.destroy();

        this.actors = null;
        this.conversations = null;
        this.items = null;
        this.locations = null;
        this.vars = null;

        Scenario.singleton = null;
      },

      parseScenarioData: function($rootObj)
      {
        var $assetObj = $rootObj.Assets;

        var $asset;

        _.each($assetObj.Actors, function($aObj) {
          $asset = new ScenarioActor($aObj);
          this.actors[$asset.id] = $asset;
        }, this);

        _.each($assetObj.UserVariables, function($vObj) {
          $asset = new ScenarioVariable($vObj);
          this.vars[$asset.name] = $asset;
        }, this);

        _.each($assetObj.Conversations, function($cObj) {
          this.conversationWaitCount++;
          $asset = new ScenarioConversation($cObj);
          $asset.once(Scenario.CONVO_READY, $.proxy(this.onConversationReadyHandler, this));
          $asset.on(Scenario.SHOW_CONVERSATION, $.proxy(this.onConversationShowHandler, this, $asset));
          $asset.on(Scenario.SHOW_DIALOG, $.proxy(this.onDialogShowHandler, this));

          ////console.log('adding convo: ' + $asset.id);
          this.conversations[$asset.id] = $asset;
          if (!this.firstConversation)
          {
            this.firstConversation = $asset;
          }
        }, this);

        _.each($assetObj.Locations, function($lObj) {
          $asset = new ScenarioLocation($lObj);
          this.locations[$asset.name] = $asset;
        }, this);

        _.each($assetObj.Items, function($iObj) {
          $asset = new ScenarioItem($iObj);
          this.items[$asset.name] = $asset;
          if ($asset.isReady !== true)
          {
            this.conversationWaitCount++;
            $asset.once(Scenario.ITEM_READY, $.proxy(this.onConversationReadyHandler, this));
          }
        }, this);

        this.maxItems = this.conversationWaitCount;
        this.updateLoader();

        /*_.each($assetObj, function($obj, $key) {
          //console.log($key);

          switch ($key)
          {
            case 'Actors':
              _.each($assetObj.Actors, function($aObj) {
                $asset = new ScenarioActor($aObj);
                this.actors[$asset.id] = $asset;
              }, this);
            break;
            case 'Items':
              _.each($assetObj.Items, function($iObj) {
                $asset = new ScenarioItem($iObj);
                this.items[$asset.name] = $asset;
                if ($asset.ready !== true)
                {
                  this.conversationWaitCount++;
                  $asset.once(Scenario.ITEM_READY, $.proxy(this.onConversationReadyHandler, this));
                }
              }, this);
            break;
            case 'Locations':
              _.each($assetObj.Locations, function($lObj) {
                $asset = new ScenarioLocation($lObj);
                this.locations[$asset.name] = $asset;
              }, this);
            break;
            case 'Conversations':
              _.each($assetObj.Conversations, function($cObj) {
                this.conversationWaitCount++;
                $asset = new ScenarioConversation($cObj);
                $asset.once(Scenario.CONVO_READY, $.proxy(this.onConversationReadyHandler, this));
                $asset.on(Scenario.SHOW_CONVERSATION, $.proxy(this.onConversationShowHandler, this));
                $asset.on(Scenario.SHOW_DIALOG, $.proxy(this.onDialogShowHandler, this));

                ////console.log('adding convo: ' + $asset.id);
                this.conversations[$asset.id] = $asset;
                if (!this.firstConversation)
                {
                  this.firstConversation = $asset;
                }
              }, this);
            break;
            case 'UserVariables':
              _.each($assetObj.UserVariables, function($vObj) {
                $asset = new ScenarioVariable($vObj);
                this.vars[$asset.name] = $asset;
              }, this);
            break;
          }
        }, this);*/
        _.delay(function() {
          ScenarioItem.mapItems();
          ScenarioDialog.evaluateDialogNodes();
        }, 500, this);
      },

      onConversationReadyHandler: function($convo)
      {
        //console.log('convo ready', $convo);
        $convo.off(Scenario.SCENARIO_READY, this.onConversationReadyHandler);
        this.conversationWaitCount--;
        this.checkScenarioReady();
      },

      updateLoader: function()
      {
        var _perc = (this.maxItems - this.conversationWaitCount) / this.maxItems;
        this.trigger(Scenario.UPDATE_LOADING, _perc);
      },

      checkScenarioReady: function()
      {
        //console.log('checking scenario ready');
        this.updateLoader();
        if (this.conversationWaitCount === 0)
        {
          //ScenarioItem.mapItems();
          // if (!this.assetsMapped)
          // {
          //   this.assetMapped = true;
          //   ScenarioDialog.evaluateDialogNodes();
          //   return;
          // }

          if (ScenarioDialog.jsonErrorArr.length > 0)
          {
            console.warn('Missing Json Files for Mouth Movement');
            console.table(ScenarioDialog.jsonErrorArr);
          }
          if (ScenarioItem.assetMapErrorArr.length > 0)
          {
            console.warn('Missing ScenarioItem Assets');
            console.table(ScenarioItem.assetMapErrorArr);
          }
          if (ScenarioConversation.viewErrorArr.length > 0)
          {
            console.warn('Missing ScenarioConversation Views');
            console.table(ScenarioConversation.viewErrorArr);
          }

          this.trigger(Scenario.SCENARIO_READY);
        }
      },

      registerDialogNodes: function()
      {
        _.each(ScenarioDialog.instancesArr, function($dialog) {
          $dialog.on('FOLLOW_DIALOG_LINK', $.proxy(this.onFollowDialogLink, this));
          $dialog.on('DIALOG_COMPLETE', $.proxy(this.onDialogCompleteHandler, this));
          $dialog.on(Scenario.UPDATE_FEEDBACK_PROGRESS, $.proxy(this.onFeedbackProgressHandler, this));
        }, this);
      },

      onFeedbackProgressHandler: function($e)
      {
        this.dispatchEvent($e);
      },

      onConversationShowHandler: function(data)
      {
        /*if ($e.noggin !== this.activeConversation)
        {
          this.lastConversation = this.activeConversation;
          this.dispatchEvent(new NLEvent(Scenario.HIDE_CONVERSATION, this.lastConversation));
        }*/

        this.activeConversation = data;
        this.trigger(Scenario.SHOW_CONVERSATION, data);
      },

      onDialogShowHandler: function(data)
      {
        this.trigger(Scenario.SHOW_DIALOG, data);
      },

      onDialogCompleteHandler: function($e)
      {

      },

      onMapDialogLink: function($e) // dialog_link
      {

      },

      onFollowDialogLink: function(data) // dialog_link
      {
        var $link = data;
        var $newDialog = $link.destinationDialog();

        if ($newDialog.getAvailable())
        {
          ////console.log('DIALOG AVAILABLE');
          ////console.log('Active Convo: ' + this.activeConversation.id);
          ////console.log('Parent Convo: ' + $newDialog.parentConvo.id);
          if ($newDialog.parentConvo.id !== this.activeConversation.id)
          {
            $newDialog.parentConvo.begin();
            /*//console.log('LOAD CONVO');
            this.dispatchEvent(new NLEvent(LOAD_CONVERSATION, $newDialog.parentConvo));*/
          }
          else
          {
            ////console.log('CHECK DIALOG');
            this.activeConversation.checkDialog($newDialog);
          }
        }
        else
        {
          this.activeConversation.checkDialog($newDialog);
        }
      }

    /*****************************************************************************************************************///}

    });

    Scenario.singleton = null;

    Scenario.printVarValues = function()
    {
      var $key;
      var $var;
      //console.log('VARS-------------------------', 2);
      for ($key in Scenario.singleton.vars)
      {
        $var = Scenario.singleton.vars[$key];
        //console.log($var.toString());
      }
    };

    Scenario.printLocationPerformance = function()
    {
      var $key;
      var $var;
      //console.log('ACTIVITIES------(Locations)--------------', 2);
      for ($key in Scenario.singleton.locations)
      {
        $var = Scenario.singleton.locations[$key];
        //console.log($var.toString());
      }
    };

    Scenario.printItems = function()
    {
      var $key;
      var $var;
      //console.log('View Assets------(Items)--------------', 2);
      for ($key in Scenario.singleton.items)
      {
        $var = Scenario.singleton.items[$key];
        //console.log($var.toString());
      }
    };

    Scenario.finishScenario = function()
    {
      Scenario.singleton.trigger(Scenario.SCENARIO_COMPLETE);
    };

    Scenario.updateItemFrames = function()
    {
      ScenarioItem.updateItemFrames();
    };

    Scenario.resetLookVars = function()
    {
      var $var;
      $var = Scenario.getVariableByName('lookingLeft');
      if ($var)
        $var.setValue(false);

      $var = Scenario.getVariableByName('lookingRight');
      if ($var)
        $var.setValue(false);
    };

    Scenario.updateDisplay = function()
    {
      Scenario.singleton.activeConversation.updateActiveHotspots();
      Scenario.updateItemFrames();
    };

    Scenario.updatePoints = function()
    {
      Scenario.singleton.trigger(Scenario.UPDATE_POINTS);
    };

    Scenario.feedbackStarted = function($dialog)
    {
      Scenario.singleton.activeDialog = $dialog;
      Scenario.singleton.trigger(Scenario.FEEDBACK_STARTED, $dialog);
    };

    Scenario.feedbackComplete = function()
    {
      if (Scenario.singleton)
      {
        Scenario.singleton.activeDialog = null;
        Scenario.singleton.trigger(Scenario.FEEDBACK_COMPLETE);
      }
    };

    Scenario.setVariable = function($name, $value)
    {
      //console.log('setting var', $name, $value);
      $value = ($value === undefined) ? null : $value;
      Scenario.singleton.vars[$name] = $value;
      //console.log(Scenario.singleton, Scenario.singleton.vars);
    };

    Scenario.getVariableByName = function($name)
    {
      return Scenario.singleton.vars[$name];
    };

    Scenario.getVariableValueByName = function($name)
    {
      var $var = Scenario.getVariableByName($name);
      if (!$var)
        return null;

      var $value = (typeof($var) === 'string') ? $var : $var.currentValue;
      return $value;//($var) ? $value : null;
    };

    Scenario.getFeedbackVars = function()
    {
      var $arr = [];
      //var $var;

      _.each(ScenarioVariable.instancesArr, function($var) {
        if ($var.name.indexOf('feedback_') === 0)
        {
          $arr.push($var);
        }
      });

      return $arr;
    };

    Scenario.getActorByID = function($id)
    {
      return Scenario.singleton.actors[$id] || null;
    };

    Scenario.getActorByName = function($name)
    {
      var $actor;
      for (var $key in Scenario.singleton.actors)
      {
        $actor = Scenario.singleton.actors[$key];
        if ($actor.name === $name)
        {
          return $actor;
        }
      }
      return null;
    };

    Scenario.getLocationByName = function($name)
    {
      return Scenario.singleton.locations[$name] || null;
    };

    Scenario.getItemByName = function($name)
    {
      return Scenario.singleton.items[$name] || null;
    };

    Scenario.getConversationByID = function($id)
    {
      return Scenario.singleton.conversations[$id] || null;
    };

    Scenario.getDialogByLocationName = function($name)
    {
      var $convo;
      var $dialog;

      for (var $i in Scenario.singleton.conversations)
      {
        $convo = Scenario.singleton.conversations[$i];
        for (var $a in $convo.dialogArr)
        {
          $dialog = $convo.dialogArr[$a];
          if ($dialog.nodeType === Scenario.NODE_TYPE_ACTIVITY && $dialog.description === $name)
          {
            return $dialog;
          }
        }
      }

      return null;
    };

    Scenario.buildDebug = function()
    {
      if (Engine.module('Cheats').settings.chatDebug === true)
      {
        ChatmapperDebug.openDebug(Scenario.singleton);
      }
    };

    Scenario.updateDebug = function()
    {
      if (Engine.module('Cheats').settings.chatDebug === true)
      {
        ChatmapperDebug.updateMapper();
      }
    };

    Scenario.clearDebug = function($close)
    {
      $close = $close === undefined ? false : $close;
      if (Engine.module('Cheats').settings.chatDebug === true)
      {
        ChatmapperDebug.clearMapper($close);
      }
    };

    Scenario.NODE_COLOR_0 = 0; // none ??
    Scenario.NODE_COLOR_ORANGE = 1; // orange // chat conversation
    Scenario.NODE_COLOR_YELLOW = 2; // yellow // activity
    Scenario.NODE_COLOR_GREEN = 3; // green // correct feedback and meter increase
    Scenario.NODE_COLOR_BLUE = 4; // blue // radial menu
    Scenario.NODE_COLOR_5 = 5; // n/a ??
    Scenario.NODE_COLOR_PINK = 6; // pink // incorrect feedback and meter decrease
    Scenario.NODE_COLOR_PURPLE = 7; // purple // hotspot group
    Scenario.NODE_COLOR_WHITE = 8; // white // none

    Scenario.NODE_TYPE_ROOT = 'NODE_TYPE_ROOT';
    Scenario.NODE_TYPE_FEEDBACK = 'NODE_TYPE_FEEDBACK';
    Scenario.NODE_TYPE_FOLLOW = 'NODE_TYPE_FOLLOW';
    Scenario.NODE_TYPE_TREE = 'NODE_TYPE_TREE';
    Scenario.NODE_TYPE_MENU = 'NODE_TYPE_MENU';
    Scenario.NODE_TYPE_HOTSPOT = 'NODE_TYPE_HOTSPOT';
    Scenario.NODE_TYPE_RADIAL = 'NODE_TYPE_RADIAL';
    Scenario.NODE_TYPE_CHAT = 'NODE_TYPE_CHAT';
    Scenario.NODE_TYPE_ACTIVITY = 'NODE_TYPE_ACTIVITY';
    Scenario.NODE_TYPE_ENDPOINT = 'NODE_TYPE_ENDPOINT';

    Scenario.SCENARIO_READY = 'SCENARIO_READY';
    Scenario.CONVO_READY = 'CONVO_READY';
    Scenario.ITEM_READY = 'ITEM_READY';
    Scenario.SCENARIO_COMPLETE = 'SCENARIO_COMPLETE';

    Scenario.CONVERSATION_READY = 'CONVERSATION_READY';
    Scenario.SHOW_CONVERSATION = 'SHOW_CONVERSATION';
    Scenario.HIDE_CONVERSATION = 'HIDE_CONVERSATION';

    Scenario.FEEDBACK_STARTED = 'FEEDBACK_STARTED';
    Scenario.FEEDBACK_COMPLETE = 'FEEDBACK_COMPLETE';
    Scenario.UPDATE_FEEDBACK_PROGRESS = 'UPDATE_FEEDBACK_PROGRESS';

    Scenario.UPDATE_POINTS = 'UPDATE_POINTS';

    Scenario.SHOW_DIALOG = 'SHOW_DIALOG';
    Scenario.SHOW_BLOCKER = 'SHOW_BLOCKER';
    Scenario.HIDE_BLOCKER = 'HIDE_BLOCKER';

    Scenario.LOAD_CONVERSATION = 'LOAD_CONVERSATION';
    Scenario.LOAD_CONVERSATION_BY_ID = 'LOAD_CONVERSATION_BY_ID';

    Scenario.LOCATION_READY = 'LOCATION_READY';
    Scenario.LOCATION_ERROR = 'LOCATION_ERROR';
    Scenario.ACTIVITY_READY = 'ACTIVITY_READY';
    Scenario.LOCATION_FATAL = 'ACTIVITY_READY';
    Scenario.ACTIVITY_COMPLETE = 'ACTIVITY_COMPLETE';
    Scenario.UPDATE_LOADING = 'UPDATE_LOADING';
    Scenario.UPDATE_ACTIVITY_LOADING = 'UPDATE_ACTIVITY_LOADING';

    Scenario.SKIP_MAPPER_AUDIO = 'SKIP_MAPPER_AUDIO';

    return Scenario;

  }
);

